import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react'
import { connect } from 'react-redux';
import './UpdateCellularProgramSuccessPage'
import { Container, Row } from 'reactstrap';
import images from '../../../DisconnectPhotos/images'
import { goToPage } from '../../../DisconnectServiceSlice'
import gaParams from '../../../../../../utilities/analytics/constants';
import { gaEvent } from '../../../../../../utilities/analytics/tracking';
import { clearStateHistoryAction } from '../../../../../../utilities/stateHistory/stateHistorySlice';

function UpdateCellularProgramSuccessPage(props) {

    async function redirect() {
        var content = await props.context.loadContentByPath(props.redirectTo);
        props.context.navigateTo(content);
    }

    useEffect(() => {
        if (typeof window.scrollTo === "function") { 
            window.scrollTo(0, 0);
        } 
        gaEvent(gaParams.DISCONNECT_ENTER_UPGRADED_CELLULAR_NEW_PACKAGE.category, gaParams.DISCONNECT_ENTER_UPGRADED_CELLULAR_NEW_PACKAGE.eventType, gaParams.DISCONNECT_ENTER_UPGRADED_CELLULAR_NEW_PACKAGE.eventParams);
        props.clearStateHistoryAction();
      }, [])

    return (
        <Container className="UpdateCellularProgramSuccessPage-root">
            <Row className="main-header-row">
                <h3 className="main-header">מעולה</h3>
            </Row>
            <Row className="paragraph-txt-row">
                <div className="paragraph-txt">החבילה התעדכנה בהתאם לבקשתך <br/> העדכון יכנס לתוקף במחזור חיוב {props.billCycle} הקרוב</div>
            </Row>
            <Row className="picture-row">
                <div className="pic-div">
                    <Image alt="image" src={images.updatedCellular} />
                </div>
            </Row>
            <Row className="btn-row">
                <div className="white-btn" onClick={()=> redirect()}>תודה</div>
            </Row>
        </Container>
    )
}

const mapStateToProps = (state) => ({
    stepInProcess: state.disconnectServicesBlock.stepInProcess,
    stepParams: state.disconnectServicesBlock.stepParams,
    billCycle: state.disconnectServicesBlock.serviceToDisconnect.billCycle
  });
  
  const mapDispatchToProps = {
    goToPage,
    clearStateHistoryAction
  };

  export default connect(mapStateToProps, mapDispatchToProps)(UpdateCellularProgramSuccessPage);